import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import connect from 'components/lib/connect';
import AttributeDef from 'models/configuration/attribute_def';
import CustomAttributeBase from './custom_attribute_base';
import EditableFieldControlled from 'components/lib/editable_field_controlled';
import UpdateCustomAttributes from 'actions/customer_profile/update_custom_attributes';
import { getPercentAttrAsNumber } from '../lib/custom_attributes_helper';
import PercentCustomAttributeGraphic from './percent_custom_attribute_graphic';

const EditablePercentCustomAttributeBase = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const EditablePercentCustomAttributePercentage = styled.div`
  flex-basis: 25%;
`;

const EditablePercentCustomAttributePercentBar = styled.div`
  flex-basis: 75%;
  padding-left: 10px;
`;

function EditablePercentCustomAttribute({ def, value, renderProps, isDisabled, isResponsePending, onSubmit }) {
  if (!def.type === 'PERCENT') {
    return null;
  }

  let renderedValue = (
    <EditableFieldControlled
      className="editableStringCustomAttribute-input"
      disabled={isDisabled}
      pending={isResponsePending}
      readOnly={false}
      onSubmit={onSubmit}
      value={value || ''}
    />
  );

  let renderGraphic = null;
  const valAsNumber = getPercentAttrAsNumber(value);
  if (renderPropsHasHighWaterMark(renderProps) && valAsNumber && !Number.isNaN(valAsNumber)) {
    renderGraphic = <PercentCustomAttributeGraphic value={valAsNumber} highWaterMark={renderProps.highWaterMark} />;
  }

  return (
    <CustomAttributeBase className="editableCustomAttribute" label={def.label}>
      <EditablePercentCustomAttributeBase>
        <EditablePercentCustomAttributePercentage>{renderedValue}</EditablePercentCustomAttributePercentage>
        <EditablePercentCustomAttributePercentBar>{renderGraphic}</EditablePercentCustomAttributePercentBar>
      </EditablePercentCustomAttributeBase>
    </CustomAttributeBase>
  );
}

function renderPropsHasHighWaterMark(renderProps) {
  return renderProps && renderProps.hasOwnProperty('highWaterMark') && !isNaN(renderProps.highWaterMark);
}

EditablePercentCustomAttribute.propTypes = {
  def: PropTypes.instanceOf(AttributeDef).isRequired,
  value: PropTypes.string,
  renderProps: PropTypes.object,
  isDisabled: PropTypes.bool,
  isResponsePending: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export { EditablePercentCustomAttribute };

const EditablePercentCustomAttributeContainer = connect(
  mapStateToProps,
  mapExecuteToProps
)(EditablePercentCustomAttribute);

function mapStateToProps({ getProvider }, { def }) {
  let profileProvider = getProvider('profile');

  return {
    def,
    value: _.get(profileProvider.get(), ['customAttributes', def.attr]),
    isDisabled: profileProvider.isLoading() || !_(profileProvider.getErrors()).isEmpty(),
    isResponsePending: profileProvider.isPending(),
  };
}

function mapExecuteToProps(executeAction, { def }) {
  return {
    onSubmit: value => executeAction(UpdateCustomAttributes, { [def.attr]: value }),
  };
}

export default EditablePercentCustomAttributeContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/custom_attributes/editable_percent_custom_attribute.jsx